import { RemoteContracts } from '../../../data/usecases/contracts/remote-contracts'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makeDoctorsContracts = (id: number) => new RemoteContracts(`/doctor/${id}/contractors`, makeAxiosHttpClient())

export const makeContractorsContracts = (id: number) => new RemoteContracts(`/contractors/${id}/doctors`, makeAxiosHttpClient())
